import { takeEvery, put, all } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';

import apiFetcher from '../../tools/api-fetcher';
import handleError from '../../tools/error-helper';

import * as types from '../../actions/school-admin/emails/types';
import * as actions from '../../actions/school-admin/emails';

function* getNotificationTypes({ schoolId }) {
  yield put(actions.setNotificationTypesLoading(true));

  try {
    const { data } = yield apiFetcher.auth().get(`/schools/${schoolId}/notification-settings`);

    yield put(actions.setNotificationTypes(data));
  } catch (exception) {
    handleError(exception);
  }

  yield put(actions.setNotificationTypesLoading(false));
}

function* getEmailNotificationSummary({ schoolId, notificationType }) {
  yield put(actions.setNotificationSummaryLoading(notificationType, true));

  try {
    const { data } = yield apiFetcher.auth()
      .get(`/schools/${schoolId}/notification-settings/${notificationType}/summary`);

    yield put(actions.setNotificationSummary(data));
  } catch (exception) {
    handleError(exception);
  }

  yield put(actions.setNotificationSummaryLoading(notificationType, false));
}

function* updateEmailNotificationTemplate({ schoolId, notificationType, notificationEmailTemplate}) {
  yield put(actions.setNotificationEmailTemplateUpdating(true));

  try {
    yield apiFetcher.auth()
      .put(`/schools/${schoolId}/notification-settings/${notificationType}/email-template`, notificationEmailTemplate);

    yield put(actions.setNotificationEmailTemplate(notificationEmailTemplate));
    toastr.success('Notification Email Template was updated successfuly.');
  } catch (exception) {
    handleError(exception);
  }

  yield put(actions.setNotificationEmailTemplateUpdating(false));
}

function* toggleNotificationDisabled({ schoolId, notificationType, isDisabledNotification }) {
  yield put(actions.setNotificationDisableSwitching(true));

  try {
    yield apiFetcher.auth()
      .put(`/schools/${schoolId}/notification-settings/${notificationType}/disabled`, { disabled: isDisabledNotification });

    yield put(actions.setNotificationDisabled(isDisabledNotification));
  } catch (exception) {
    handleError(exception);
  }

  yield put(actions.setNotificationDisableSwitching(false));
}

export default function* schoolAdminEmailsSaga() {
  yield all([
    takeEvery(types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_GET_TYPES, getNotificationTypes),
    takeEvery(types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_GET_SUMMARY, getEmailNotificationSummary),
    takeEvery(types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_UPDATE_EMAIL_TEMPLATE, updateEmailNotificationTemplate),
    takeEvery(types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_TOGGLE_DISABLE, toggleNotificationDisabled)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/school-admin/emails.js